import { COREUI_DEVICE_ICON_MAPPING, ICON_MAPPING } from './icons'
import * as battery0 from '@/../images/device_icons/his/battery0.svg'
import * as battery20 from '@/../images/device_icons/his/battery20.svg'
import * as battery40 from '@/../images/device_icons/his/battery40.svg'
import * as battery60 from '@/../images/device_icons/his/battery60.svg'
import * as battery80 from '@/../images/device_icons/his/battery80.svg'
import * as battery100 from '@/../images/device_icons/his/battery100.svg'
import * as chp from '@/../images/device_icons/his/chp.svg'
// import * as container from '@/../images/device_icons/his/container.svg'
import * as coreuiDeviceIcons from '@/../images/device_icons/his/coreui_device_icons'
import * as wallbox from '@/../images/device_icons/his/wallbox.svg'
import * as wallboxPlugged from '@/../images/device_icons/his/wallbox_plugged.svg'
import * as wallboxUnplugged from '@/../images/device_icons/his/wallbox_unplugged.svg'
import * as wallboxWarning from '@/../images/device_icons/his/wallbox_warning.svg'
// import * as fuelcell from '@/../images/device_icons/his/fuelcell.svg'
import * as generic from '@/../images/device_icons/his/generic.svg'
import * as grid from '@/../images/device_icons/his/grid.svg'
import * as heatingelement from '@/../images/device_icons/his/heatingelement.svg'
import * as heatpump from '@/../images/device_icons/his/heatpump.svg'
import * as pv from '@/../images/device_icons/his/pv.svg'
import * as rest from '@/../images/device_icons/his/rest.svg'
import * as trafo from '@/../images/device_icons/his/trafo.svg'
import * as user from '@/../images/device_icons/his/user.svg'

const map = {
  battery: battery0,
  battery0,
  battery20,
  battery40,
  battery60,
  battery80,
  battery100,
  chp,
  // container,
  // fuelcell,
  generic,
  grid,
  heatingelement,
  heatpump,
  pv,
  rest,
  trafo,
  user,
  wallbox,
  wallboxPlugged,
  wallboxUnplugged,
  wallboxWarning
}

export function overwriteIcons() {
  Object.assign(ICON_MAPPING, map)
}

export function overwriteCoreuiDeviceIcons() {
  Object.assign(COREUI_DEVICE_ICON_MAPPING, coreuiDeviceIcons)
}
